export const getUrlParams = () => {
    const url = window.location.href.split('?')[1]
    const urlParams = new URLSearchParams(url)
    const paramsObj = Object.fromEntries(urlParams)
    return paramsObj
}

export const getFirebaseDocs = snapshot => {
    var data = []
    for (let row of snapshot.docs) {
        data.push({ id: row.id, ...row.data() })
    }
    return data
}

export const getSeconds = () => parseInt(new Date().getTime() / 1000)

export const randomString = () => [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

export const preserveLatestValuesInBooking = bookings => {
    let bookingsReversed = [...bookings].reverse()
    let newArray = []
    for (let row of bookingsReversed) {
        if (!newArray.includes(row) && !newArray.map(el => el.split('-')[0] + '-' + el.split('-')[1]).includes(row.split('-')[0] + '-' + row.split('-')[1])) {
            newArray.push(row)
        }
    }
    return newArray
}

export const getRideInfoWithoutTime = rideId => rideId.split('-')[0] + '-' + rideId.split('-')[1]

export const removeRide = (bookings, rideId) => {

    const rideInfoWithoutTime = getRideInfoWithoutTime(rideId)
    let finalRides = []
    for (let book of bookings) {
        const bookInfoWithoutTime = getRideInfoWithoutTime(book)
        console.log(bookInfoWithoutTime, rideInfoWithoutTime)
        if (bookInfoWithoutTime !== rideInfoWithoutTime) {
            finalRides.push(book)
        }
    }
    console.log('finalRides', finalRides)
    return finalRides
}